import { createTheme, responsiveFontSizes } from "@mui/material/styles";

// Same brand color denzo-waiter/denzo-web-app fall back to when a store
// hasn't customized its own theme_color — kept as a plain constant here for
// the same reason denzo-waiter does: no per-store branding to inherit in a
// staff-only app.
const BRAND_COLOR = "#c62828";

let theme = createTheme({
  shape: { borderRadius: 10 },
  palette: {
    primary: { main: BRAND_COLOR, contrastText: "#fff" },
    background: { default: "#faf7f5" },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: "none" } },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
export { BRAND_COLOR };
